import declarationProduce from './view/declarationProduce.html'

export default {
  base: {
    state: 'declaration.corporateIncomeTax.declarationProduce',
    config: {
      url: '/declarationProduce',
      abstract: true,
      template: '<div ui-view></div>',
      default: 'declaration.corporateIncomeTax.declarationProduce.list',
      title: '申报表生成',
    },
  },
  list: {
    state: 'declaration.corporateIncomeTax.declarationProduce.list',
    config: {
      url: '/list',
      template: declarationProduce,
      controller: 'declarationProduceCtrl',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/declaration/corporateIncomeTax/declarationProduce/routers.js